<template>
  <div id="lista-especialidades">
    <div v-if="ativaBuscaProfissionais" class="header">
      <strong>Nova busca por:</strong>
      <div class="options-wrapper">
        <el-button plain class="tab-button" :style="{color: corPrimaria, borderColor: corPrimaria, opacity: tab === 'ListaEspecialidades' ? 1 : 0.5}" @click="changeTab('ListaEspecialidades')">{{textoBotaoSelecaoEspecialidade}}</el-button>
        <el-button plain class="tab-button" :style="{color: corPrimaria, borderColor: corPrimaria, opacity: tab === 'BuscaProfissionais' ? 1 : 0.5}" @click="changeTab('BuscaProfissionais')">{{textoBotaoSelecaoProfissional}}</el-button>
      </div>
    </div>

    <component :is="tab"></component>
  </div>
</template>
<script>
import Listagem from '@/components/Listagem/Listagem'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'
import ErrorVazio from '@/components/Error/ErrorVazio'
import ListaEspecialidades from '@/views/53/components/ListaEspecialidades.vue'
import BuscaProfissionais from '@/views/53/components/BuscaProfissionais.vue'

export default {
  data () {
    return {
      tab: 'ListaEspecialidades',
      tabs: [
        'ListaEspecialidades',
        'BuscaProfissionais'
      ]
    }
  },
  components: { DialogDefault, Listagem, ErrorVazio, ListaEspecialidades, BuscaProfissionais },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapState('Func53', ['paciente', 'idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Func53', ['tipoServico']),
    textoBotaoSelecaoEspecialidade () {
      return this.funcionalidade.parametros.textos.textoBotaoSelecaoEspecialidade
    },
    textoBotaoSelecaoProfissional () {
      return this.funcionalidade.parametros.textos.textoBotaoSelecaoProfissional
    },
    ativaBuscaProfissionais () {
      return this.funcionalidade.parametros.ativaBuscaProfissionais
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdEpecialidade', 'setNomePrestador', 'setIdLocal', 'setTipoServico', 'setIdServico', 'setLocalAtendimento']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    async changeTab (tab) {
      this.tab = tab
    }
  },
  created () {
    this.setIdEpecialidade(null)
    this.setNomePrestador(null)
    this.setIdLocal(null)
    this.setTipoServico(null)
    this.setLocalAtendimento(null)
    this.setIdServico(null)
  }
}
</script>
<style scoped>
.tab-button {
  width: 100%;
}
.header {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 0 20px;
  margin-top: 15px;
  gap: 10px;
  margin-bottom: 15px;
}
.options-wrapper {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  align-content: center;
}
</style>
